/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Split, DefaultSplitter } from "@geoffcox/react-splitter"
import {theme} from "../../../constants/theme";


export const MAIN_BORDER_STYLE = {
  border: `2px solid ${theme.layout.header.backgroundColor}`,
  borderRadius: 10,
}
export const RIGHT_CONTENT_PANEL_STYLE = {
  flex: 1, overflow: 'auto', height: '100%',
  ...MAIN_BORDER_STYLE,
  padding: 10,
  // paddingTop: 10,
  marginLeft: 5
}
export const TREE_WRAPPER_STYLE = {
  height: '100%',
  overflow: 'auto',
  // maxWidth: '60vw',
  minWidth: '450px',
  // border: `2px solid ${theme.layout.header.backgroundColor}`,
  // borderRadius: 10,
  marginRight: 5,
}

interface IArgosExpandableContainer {
  initialLeftSize: string,
  leftSide: any,
  rightSide: any,
  style?:any,
}

const ArgosExpandableContainer = (props: IArgosExpandableContainer) => {
    const {initialLeftSize, leftSide, rightSide} = props

    return (
        <div style={{flexGrow: 1, display: 'flex', width: "100%", padding: `0 5px 5px 5px`, height: '100%'}}>
        <Split
          initialPrimarySize={initialLeftSize}
          renderSplitter={(splitterProps) => {
            return (
              <DefaultSplitter
                pixelSize={splitterProps.pixelSize}
                horizontal={splitterProps.horizontal}
                dragging={splitterProps.dragging}
              />
            )
          }}
        >
          <div style={TREE_WRAPPER_STYLE}>
            {leftSide}
          </div>
          <div style={RIGHT_CONTENT_PANEL_STYLE}>
            {rightSide}
          </div>
        </Split>
      </div>
    )
  }
  
export default ArgosExpandableContainer